import { module as BaseModule } from "modujs"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class extends BaseModule {
  init() {
    this.filterButtonsEls = this.el.querySelectorAll("[data-filter]")
    this.filterItemsEls = document.querySelectorAll("[data-filtering-item]")
    this.searchInput = this.el.querySelector("#search")

    this.bindEvents()
  }

  bindEvents() {
    this.filterButtonsEls.forEach((button) => {
      button.addEventListener("click", () => this.toggleFilter(button))
    })

    if (this.searchInput) {
      this.searchInput.addEventListener("input", (e) => {
        const hasSearchQuery = e.target.value.length > 0

        if (hasSearchQuery) {
          this.filterButtonsEls.forEach((btn) => btn.classList.remove("active"))
        }

        this.filterContent()
      })
    }
  }

  toggleFilter(button) {
    if (this.searchInput.value.length > 0) {
      this.searchInput.value = ""
    }

    const isActive = button.classList.contains("active")
    this.filterButtonsEls.forEach((btn) => btn.classList.remove("active"))

    if (!isActive) {
      button.classList.add("active")
    }

    this.filterContent()
  }

  filterContent() {
    const searchQuery = this.searchInput.value.toLowerCase().trim()

    if (searchQuery) {
      this.filterItemsEls.forEach((item) => {
        const itemTags = item.getAttribute("data-filtering-item").toLowerCase()
        const itemTitle = item
          .getAttribute("data-filtering-title")
          .toLowerCase()
        const matchesTags = itemTags.includes(searchQuery)
        const matchesTitle = itemTitle.includes(searchQuery)

        item.style.display = matchesTags || matchesTitle ? "" : "none"
      })
    } else {
      const activeFilterButton = Array.from(this.filterButtonsEls).find(
        (button) => button.classList.contains("active")
      )

      const activeFilterTag = activeFilterButton
        ? activeFilterButton.getAttribute("data-filter")
        : null

      this.filterItemsEls.forEach((item) => {
        const itemTags = item.getAttribute("data-filtering-item").split(" ")
        item.style.display =
          !activeFilterTag || itemTags.includes(activeFilterTag) ? "" : "none"
      })
    }

    ScrollTrigger.refresh()
  }
}
